import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layouts
import PublicLayout from "./layouts/AuthLayout.js";
import PublicClientLayout from "./layouts/ClientAuthLayout.js";
import BaseLayout from "./layouts/BaseLayout";
//Admin Auth public pages
import Signin from "./Auth/Signin.js";
import ForgotPassword from "./Auth/ForgotPassword";
//Client Auth public pages
import ClientSignin from "./Auth/ClientSignin.js";
import ClientLogout from "./Auth/ClientLogout";
import ClientToken from "./Auth/ClientToken";
import ClientResetPassword from "./Auth/ClientResetPassword";
import ClientForgotPassword from "./Auth/ClientForgotPassword";
import SignUp from "./Auth/SignUp.js";

//Admin protected pages
import Dashboard from "./components/Dashboard.js";
import Clientslist from "./components/Clientslist.js";
import ClientsView from "./components/ClientsView";
import ClientsAdd from "./components/ClientsAdd";
import ClientsEdit from "./components/ClientsEdit";

import UsersList from "./components/UsersList";
import AccessTokens from "./components/AccessTokens.js";
import RefreshTokens from "./components/RefreshTokens.js";

import Customerslist from "./components/Customerslist.js";
import CustomersView from "./components/CustomersView";
import CustomersAdd from "./components/CustomersAdd";
import CustomersEdit from "./components/CustomersEdit";

import Packageslist from "./components/Packageslist.js";
import PackagesView from "./components/PackagesView";
import PackagesAdd from "./components/PackagesAdd";
import PackagesEdit from "./components/PackagesEdit";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<PublicLayout />} >
        <Route path="/" element={<Signin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>

      <Route path="/" element={<PublicClientLayout />} >
        <Route path="/signin/client" element={<ClientSignin />} />
        <Route path="/token/client" element={<ClientToken />} />
        <Route path="/reset-password/client" element={<ClientResetPassword />} />
        <Route path="/forgot-password/client" element={<ClientForgotPassword />} />
        <Route path="/signup/client" element={<SignUp />} />
      </Route>
      
      <Route path="/logout/client" element={<ClientLogout />} />

      <Route path="/" element={<BaseLayout />}>
        <Route path="/clients" element={<Clientslist />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<UsersList />} />
        <Route path="/accesstokens" element={<AccessTokens />} />
        <Route path="/refreshtokens" element={<RefreshTokens />} />
        <Route path="/clientsView/:data" element={<ClientsView />} />
        <Route path="/clientsAdd" element={<ClientsAdd />} />
        <Route path="/clientsEdit/:data" element={<ClientsEdit />} />

        <Route path="/customers" element={<Customerslist />} />     
        <Route path="/customersView/:data" element={<CustomersView />} />
        <Route path="/customersAdd" element={<CustomersAdd />} />
        <Route path="/customersEdit/:data" element={<CustomersEdit />} />


        <Route path="/packages" element={<Packageslist />} />     
        <Route path="/packagesView/:data" element={<PackagesView />} />
        <Route path="/packagesAdd" element={<PackagesAdd />} />
        <Route path="/packagesEdit/:data" element={<PackagesEdit />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
